export const cardGroupStyle = {
  marginTop: 2,
}
